import { AfterViewInit, Directive, ElementRef, HostListener, Input, OnDestroy } from '@angular/core';
import * as textMask from 'text-mask-core/dist/textMaskCore.js';
import { NgControl } from '@angular/forms';
import { PHONE_MASK } from '../helpers/mask-patterns';

const DEFAULT_MASK = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];

@Directive({
  selector: '[appMask]',
  standalone: true,

  host: {
    '(input)': 'handleInput()',
  },
})
export class MaskDirective implements AfterViewInit, OnDestroy {
  @Input() mask = DEFAULT_MASK; // dd/mm/yyyy
  @Input() initConform = false;

  maskedInputController;

  constructor(
    private element: ElementRef,
    private control: NgControl,
  ) {}

  @HostListener('input')
  handleInput(): void {
    this.maskedInputController?.update();
    const value = this.maskedInputController.state.previousConformedValue;
    // this is a hack so user is able to input date with keyboard
    if (!(this.mask.toString() === DEFAULT_MASK.toString() && value.includes('_'))) {
      this.control?.control.patchValue(value);
    }
  }

  @HostListener('paste', ['$event'])
  handlePaste(event: ClipboardEvent): void {
    const clipboardData: DataTransfer = event.clipboardData;
    const pastedText: string = clipboardData.getData('text');
    if (this.maskedInputController && pastedText) {
      if (this.control) {
        this.control.control.patchValue('');
      }
      event.preventDefault();
      const digitsOnly: string = pastedText.replace(/\D/g, '');
      let formattedText: string = '';
      if (this.mask === PHONE_MASK) {
        if (digitsOnly.length === 10) {
          formattedText = '+1' + digitsOnly;
        } else if (digitsOnly.length === 11 && digitsOnly.startsWith('1')) {
          formattedText = '+' + digitsOnly;
        } else {
          formattedText = digitsOnly;
        }
      } else {
        formattedText = pastedText;
      }
      const maskedText = textMask.conformToMask(formattedText, this.mask, {}).conformedValue;
      this.control.control.patchValue(maskedText);

      const inputElement = this.element.nativeElement;
      const position = maskedText.indexOf('_') !== -1 ? maskedText.indexOf('_') : maskedText.length;
      inputElement.setSelectionRange(position, position);
    }
  }

  ngAfterViewInit(): void {
    this.maskedInputController = textMask.createTextMaskInputElement({
      inputElement: this.element.nativeElement,
      mask: this.mask,
    });

    if (this.control && this.initConform && this.control.value) {
      const value = this.control.value + '';
      if (this.mask === PHONE_MASK && value.length === 11 && value.startsWith('1')) {
        const formattedValue = '+1' + value.substring(1, 11);
        this.control.control.patchValue(textMask.conformToMask(formattedValue, this.mask, {}).conformedValue);
      } else {
        this.control.control.patchValue(textMask.conformToMask(this.element.nativeElement.value, this.mask, {}).conformedValue);
      }
    }

    this.maskedInputController?.update();
    this.element.nativeElement.addEventListener('change', () => this.maskedInputController.update(), { passive: false });
  }

  ngOnDestroy(): void {
    // this.maskedInputController.destroy();
  }
}
